import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserContext } from '@typeDefs/home/responses/home';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeApiService {
  private http = inject(HttpClient);

  private userContext$ = this.http.get<UserContext>('/Account/GetUserContext');
  userContext = toSignal(this.userContext$, { initialValue: null });

  getPdfFile(attachmentID: string): Observable<Blob> {
    const url = '/Document/GetPdfFile';
    const params = new HttpParams().set("attachmentID", attachmentID);

    return this.http.get(url, { params: params, responseType: 'blob' });
  }
}
